import NextImage from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC, useContext } from 'react'
import { TEST_IDS } from '../../__tests__/testUtils/constants'
import { AppDataContext } from '../../providers/AppData'
import { CLAIM_YOUR_PROFILE_ROUTES } from '../ClaimYourProfile/constants'
import { WpaHeaderContainer } from './styles'
import { PROVIDERS_VARIANTS } from '../ClaimYourProfile/types'
import getDomainName from '../../utils/getDomainName'

const getProvidersData = (variant: PROVIDERS_VARIANTS, shouldReverse?: boolean) => {
  const data = {
    [PROVIDERS_VARIANTS.HCA]: {
      logo: '/hermes-static/hca-logo.png',
      logoAlt: 'HCA logo',
      containerSx: { backgroundColor: '#FCE9C5', paddingLeft: '54px', border: 'none' }
    },
    [PROVIDERS_VARIANTS.WPA]: {
      logo: `/hermes-static/wpa-logo-${shouldReverse ? 'navy' : 'light'}.svg`,
      logoAlt: 'WPA logo',
      containerSx: { backgroundColor: shouldReverse ? '#fff' : '#142F76' }
    }
  }

  return data[variant]
}

export type WpaHeaderProps = {
  shouldReverse?: boolean
  logoAlign?: 'flex-end' | 'flex-start' | 'center'
  variant: PROVIDERS_VARIANTS
}

const ProviderHeader: FC<WpaHeaderProps> = ({ variant, shouldReverse, logoAlign = 'flex-start' }) => {
  const router = useRouter()
  const { locale } = useContext(AppDataContext)
  const { logo, logoAlt, containerSx } = getProvidersData(variant, shouldReverse)
  const domainName = getDomainName()
  const isClaimProfileRoute = CLAIM_YOUR_PROFILE_ROUTES.PROVIDERS.some((route) => router.pathname.includes(route))

  const modifiedLocale = router.locale === 'ar-ae' ? 'en-ae' : locale

  return (
    <WpaHeaderContainer
      container
      data-testid={TEST_IDS.HEADER_FIND_PAGE}
      sx={containerSx}
      alignItems="center"
      alignContent="center"
      logoAlign={logoAlign}
    >
      <Link href={isClaimProfileRoute ? `${domainName}/uk` : '/'} locale={modifiedLocale}>
        <NextImage src={logo} alt={logoAlt} width={400} height={40} priority style={{ cursor: 'pointer' }} />
      </Link>
    </WpaHeaderContainer>
  )
}

export default ProviderHeader
